import Typography from 'components/generics/texts/Typography';
import { AnimatePresence, motion } from 'framer-motion';
import BaseLandaFinancingSection from 'pages/lend/components/BaseComponents/BaseLandaFinancingSection';
import ChevronLeft from 'public/assets/icons/chevron_left.svg';
import React from 'react';
import { DebtType } from 'types/debt-types';
import classes from './index.module.scss';

interface Props {
  debt: DebtType;
  question: string;
  answer?: string;
  answerComponent?: React.ReactNode;
}

const LandaFinancingFAQBox = ({ question, answer, answerComponent }: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <BaseLandaFinancingSection className={classes.container}>
      <motion.div
        layout={'position'}
        className={classes.questionContainer}
        initial={'closed'}
        onClick={() => setIsOpen(!isOpen)}
      >
        <motion.div className={classes.title}>{question}</motion.div>
        <motion.div
          animate={isOpen ? 'open' : 'closed'}
          layout={'position'}
          variants={{
            open: { rotate: 90 },
            closed: { rotate: 270 },
          }}
          initial={'closed'}
          transition={{ duration: 0.2 }}
          className={classes.arrowContainer}
        >
          <ChevronLeft className={classes.arrow} />
        </motion.div>
      </motion.div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            layout={'position'}
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: 'auto', marginTop: 16 },
              collapsed: { opacity: 0, height: 0, marginTop: 0 },
            }}
            className={classes.subtitleContainer}
          >
            {answer && (
              <Typography className={classes.subtitle}>{answer}</Typography>
            )}
            {answerComponent && answerComponent}
          </motion.div>
        )}
      </AnimatePresence>
    </BaseLandaFinancingSection>
  );
};

export default LandaFinancingFAQBox;
